export default "__VITE_ASSET__ZkcnG0xb__"